<fui-action [title]="title">
    <fui-icon [height]="10" [icon]="'close'" [width]="10"></fui-icon>
</fui-action>
